<template>
  <!--选择预约时间弹窗-->
  <div class="select-time-popup">
    <popup :value="value" @input="changeShow" hide-on-blur height="100%">
      <div class="time-setting-wrapper">
        <div class="days">
          <ul class="week-head">
            <li
              v-for="(date, index) in dates"
              :key="date.date"
              :class="{
                'week-head__day': true,
                'week-head__day--active': activeDate === date.date,
                'week-head__day--disabled': !canSwitchDate && index
              }"
              @click="() => dateClick(date, index)"
            >
              <span>{{ date.week }}</span>
              <span>{{ date.date.substr(5) }}</span>
            </li>
          </ul>
        </div>
        <div class="select-date">
          <span v-if="canSwitchDate" @click="showCalendar = true">其他日期</span>
        </div>
        <ul class="times">
          <li class="times__half-day">上午</li>
          <li
            v-for="time in morningTimes"
            :key="time.time"
            class="cell"
            @click="() => selectTime(time)"
          >
            <div
              :class="{
                cell__time: true,
                'cell__time--selected': isSelectedTime(time),
                'cell__time--disabled': time.is_overtime || !canSelectTime
              }"
            >
              <span>{{ time.time }}</span>
              <span>{{
                restStatus({
                  done: time.appointed_num,
                  total: time.limit_num,
                  status: !time.is_overtime && canSelectTime
                })
              }}</span>
            </div>
          </li>
        </ul>
        <ul class="times">
          <li class="times__half-day">下午</li>
          <li
            v-for="time in afternoonTimes"
            :key="time.time"
            class="cell"
            @click="() => selectTime(time)"
          >
            <div
              :class="{
                cell__time: true,
                'cell__time--selected': isSelectedTime(time),
                'cell__time--disabled': time.is_overtime || !canSelectTime
              }"
            >
              <span>{{ time.time }}</span>
              <span>{{
                restStatus({
                  done: time.appointed_num,
                  total: time.limit_num,
                  status: !time.is_overtime && canSelectTime
                })
              }}</span>
            </div>
          </li>
        </ul>
        <footer @click="confirm">确认</footer>
      </div>
      <CustomCalendar
        v-if="startDate"
        :showCalendar.sync="showCalendar"
        v-model="selectedDate"
        :start-date="startDate"
      />
    </popup>

    <!-- 服务顾问列表弹窗 -->
    <div
      v-if="groupDialogVisible"
      class="select-time-popup__service-advisers-wrapper"
    >
      <div class="select-time-popup__service-advisers__mask" />
      <popup v-model="groupDialogVisible" :hide-on-blur="false">
        <div class="select-time-popup__service-advisers">
          <div class="select-time-popup__service-advisers__header">
            <div class="select-time-popup__service-advisers__header__title">
              请选择服务顾问
            </div>
            <span class="vux-close" @click="handleCloseGroupDialog" />
          </div>
          <div class="select-time-popup__service-advisers__list">
            <div
              class="select-time-popup__service-advisers__list__item"
              @click="handleSelectServiceAdvisor(-1)"
            >
              <div class="select-time-popup__service-advisers__list__name">
                不指定
              </div>
              <div class="select-time-popup__service-advisers__list__check">
                <CheckIcon :value="tempSelected.consultant_id === -1" />
              </div>
            </div>
            <div
              v-for="(consultant,
              index) in tempSelected.service_consultant_stats"
              :key="consultant.consultant_id"
              class="select-time-popup__service-advisers__list__item"
              @click="handleSelectServiceAdvisor(index)"
            >
              <div class="select-time-popup__service-advisers__list__name">
                <span>{{ consultant.consultant_display }}</span>
                <span
                  :class="{
                    'select-time-popup__service-advisers__list__name--warning':
                      consultant.appointed_num >= consultant.booking_limit
                  }"
                >
                  ({{ consultant.appointed_num }}/{{
                    consultant.booking_limit
                  }})
                </span>
              </div>
              <div class="select-time-popup__service-advisers__list__check">
                <CheckIcon
                  :value="
                    tempSelected &&
                      consultant.consultant_id === tempSelected.consultant_id
                  "
                />
              </div>
            </div>
          </div>
          <div
            class="select-time-popup__service-advisers__footer"
            @click="handleConfirm"
          >
            确定
          </div>
        </div>
      </popup>
    </div>

    <Confirm
      v-model="conformAddExtraVisible"
      title="提示"
      cancelText="取消"
      confirmText="确认"
      @on-confirm="handleConfirmAddExtra"
    >
      <p style="text-align: center;">
        已经超过原定时间段内预约数量，确定增加吗？
      </p>
    </Confirm>
  </div>
</template>

<script>
import { Popup, Confirm, CheckIcon } from '@lx-frontend/cvux'
import CustomCalendar from '../components/CustomCalendar.vue'
import util from '@/common/util'
import authApi from '@/common/auth'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    value: {
      default: false,
      type: Boolean
    },
    // 1=可以修改今天、2、3=不可以修改、4=可以跨天修改
    appointedTimeType: {
      type: Number,
      default: 4
    },
    serviceBookingId: {
      default: '',
      type: String
    },
    selectedInfo: {
      type: Object
    },
    cb: {
      required: true,
      type: Function
    }
  },
  data() {
    return {
      dates: [], // 可以预约的日期
      times: [], // 选中日期可预约时间段
      activeDate: '', // 选中的日期
      showCalendar: false,
      selectedDate: '',
      settingData: {},
      startDate: util.formatTime(
        new Date(+new Date() + 1000 * 60 * 60 * 24),
        'yyyy-MM-dd'
      ),
      groupDialogVisible: false,
      hasAddExtraAuth: false,
      conformAddExtraVisible: false,
      // 已选择的信息
      selected: null,
      // 临时选择的信息
      tempSelected: null
    }
  },
  created() {
    this.getBasicSetup()
    this.$store.state.promiseAuth.then(auth => {
      this.hasAddExtraAuth = authApi.haveEveryAuth(
        [authApi.serviceBooking.add_extra],
        auth.authList
      )
    })
  },
  computed: {
    morningTimes() {
      if (this.times.length > 0) {
        return this.times.filter(ele => parseInt(ele.time.split(':')[0]) < 12)
      }
      return []
    },
    afternoonTimes() {
      if (this.times.length > 0) {
        return this.times.filter(ele => parseInt(ele.time.split(':')[0]) >= 12)
      }
      return []
    },
    canSwitchDate() {
      return this.appointedTimeType === 4
    },
    canSelectTime() {
      return [1, 4].includes(this.appointedTimeType)
    }
  },
  components: { Popup, CustomCalendar, Confirm, CheckIcon },
  watch: {
    async value(newVal) {
      if (newVal) {
        this.initData()
      }
    },
    selectedDate(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initData(newVal)
      }
    }
  },
  methods: {
    isSelectedTime(item) {
      return (
        this.selected &&
        this.selected.date === this.activeDate &&
        this.selected.time === item.time
      )
    },
    restStatus({ done, total, status }) {
      if (!status) {
        return '不可预约'
      }
      if (done >= total && !this.hasAddExtraAuth) {
        return '已约满'
      }
      return done + ' / ' + total
    },
    async initData(date = '') {
      // this.activeDate = ''
      const {
        code,
        data,
        message
      } = await this.$rest.appointment.getBookingDate({
        date,
        // 更改预约时需要带上预约ID
        ...(this.serviceBookingId && {
          service_booking_id: this.serviceBookingId
        })
      })
      if (code === 0) {
        this.dates = data
        const param = date || data[0].date
        this.dateClick({ date: param })
        // this.activeDate = param
        // if (!this.startDate) {
        //   this.startDate = data[0].date
        // }
      } else {
        this.showToast(message)
      }
    },
    async getBasicSetup() {
      const {
        code,
        data,
        message
      } = await this.$rest.appointment.getBasicSetup()
      if (code === 0) this.settingData = data
    },
    dateClick({ date }, index = 0) {
      // 是否允许切换日期，新增预约则没任何限制
      // index > 0 则说明点击了跨天日期
      if (index && !this.canSwitchDate) {
        return
      }
      this.activeDate = date
      this.updateTimes(date)
    },
    changeShow(val) {
      if (!val) {
        this.initData()
      }
      this.$emit('input', val)
    },
    selectTime(item) {
      const {
        appointed_num: appointedNum,
        limit_num: limitNum,
        is_overtime
      } = item

      if (
        is_overtime ||
        !this.canSelectTime ||
        appointedNum > limitNum ||
        (!this.hasAddExtraAuth && appointedNum === limitNum)
      ) {
        return
      }

      const cloneItem = cloneDeep(item)
      const cloneSelected = cloneDeep(this.selected)

      let _consultantInfo = {
        consultant_id: -1,
        consultant_display: ''
      }

      if (this.selectedInfo.consultant_id !== -1) {
        const _consultantIndex = cloneItem.service_consultant_stats.findIndex(v => v.consultant_id === this.selectedInfo.consultant_id)
        if (_consultantIndex !== -1) {
          _consultantInfo = {
            consultant_id: this.selectedInfo.consultant_id,
            consultant_display: this.selectedInfo.consultant_display
          }
          const [_consultantItem] = cloneItem.service_consultant_stats.splice(_consultantIndex, 1)
          cloneItem.service_consultant_stats.unshift(_consultantItem)
        }
      }

      this.tempSelected =
        cloneSelected &&
        cloneSelected.date === this.activeDate &&
        cloneSelected.time === item.time
          ? { ...cloneItem, ...cloneSelected, ..._consultantInfo }
          : { ...cloneItem, date: this.activeDate, ..._consultantInfo }
      this.groupDialogVisible = true
    },
    handleCloseGroupDialog() {
      this.groupDialogVisible = false
      this.tempSelected = null
    },
    handleSelectServiceAdvisor(index) {
      if (index === -1) {
        this.tempSelected = {
          ...this.tempSelected,
          consultant_id: -1,
          consultant_display: ''
        }

        return
      }

      const consultant = this.tempSelected.service_consultant_stats[index]
      this.tempSelected = {
        ...this.tempSelected,
        consultant_id: consultant.consultant_id,
        consultant_display: consultant.consultant_display
      }
    },
    handleConfirm() {
      this.groupDialogVisible = false
      this.selected = cloneDeep(this.tempSelected)
      this.tempSelected = null
    },
    // 关闭时间选择弹窗
    close() {
      this.$emit('input', false)
    },
    confirm() {
      if (!this.selected) {
        this.showToast('您还没有选择时间')
        return
      }

      // 从编辑过来可能不是完整的结构 手动去获取一次最新的预约时间信息
      const current = this.times.find(item => item.time === this.selected.time)

      // 有超约权限，且已约满
      if (this.hasAddExtraAuth && current.appointed_num === current.limit_num) {
        this.conformAddExtraVisible = true
        return
      }

      this.cb({
        ...current,
        ...this.selected,
        value: `${this.activeDate} ${this.selected.time} ${
          this.selected.consultant_display
        }`
      })
    },
    handleConfirmAddExtra() {
      // 从编辑过来可能不是完整的结构 手动去获取一次最新的预约时间信息
      const current = this.times.find(item => item.time === this.selected.time)

      this.cb({
        ...current,
        ...this.selected,
        value: `${this.activeDate} ${this.selected.time} ${
          this.selected.consultant_display
        }`
      })
    },
    async updateTimes(timeStr) {
      const { code, data, message } = await this.$rest.appointment.getPeriods({
        date: timeStr
      })
      if (code === 0) {
        this.times = data
        if (this.selectedInfo && this.selectedInfo.date === this.activeDate) {
          this.selected = { ...this.selectedInfo }
        } else {
          this.selected = null
        }
      } else {
        this.showToast(message)
      }
    }
  }
}
</script>

<style lang="less">
@import "../../stylesheets/base/fn.less";
.select-time-popup {
  .vux-popup-dialog {
    z-index: 900;
  }
  .weui_mask {
    display: block;
  }

  &__service-advisers-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1000;
    overflow: hidden;
  }

  &__service-advisers {
    width: 100%;
    height: 720 / @w2;
    box-sizing: border-box;
    padding: 30 / @w2;

    &__mask {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &__title {
        font-weight: 600;
        font-size: 34 / @w2;
        color: #1f263d;
        line-height: 48 / @w2;
      }

      .vux-close {
        width: 35 / @w2;
        height: 35 / @w2;
        color: #1f263d;
      }
    }

    &__list {
      margin-top: 32 / @w2;
      height: 440 / @w2;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch; // iOS 平滑滚动

      // 隐藏滚动条 - 兼容安卓和 iOS
      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
      }

      // 兼容 Firefox
      scrollbar-width: none;
      -ms-overflow-style: none;

      &__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 34 / @w2 0;
        border-bottom: 1px solid #e7e8e9;
        box-sizing: border-box;
      }

      &__name {
        font-size: 30 / @w2;
        color: #1f263d;

        &--warning {
          color: red;
        }
      }

      .weui_icon_success:before {
        color: #3a5999;
      }
    }

    &__footer {
      margin-top: 49 / @w2;
      width: 100%;
      background: #3a5999;
      box-sizing: border-box;
      border-radius: 5 / @w2;
      padding: 20 / @w2 0;
      color: #fff;
      text-align: center;
      font-size: 32 / @w2;
    }
  }
}

.group-appointment-dialog {
  .weui_dialog {
    background: #fff;
  }
  &__content {
    min-height: 100 / @w2;
    max-height: 500 / @w2;
    overflow-y: auto;
    padding: 35 / @w2 35 / @w2 0;
    .gap-y(32 / @w2);
  }
  &__subtitle {
    text-align: left;
    font-size: 32 / @w2;
    line-height: 45 / @w2;
    font-weight: bold;
    padding: 0 20 / @w2 20 / @w2 20 / @w2;
  }
  &__items {
    padding: 8 / @w2 30 / @w2;
    border-radius: 16 / @w2;
    background: #f8f9fc;
  }
  &__item {
    display: flex;
    height: 72 / @w2;
    line-height: 72 / @w2;
    justify-content: space-between;
    font-size: 26 / @w2;
    border-bottom: 1px solid #f0f0f0;
    color: #333;
    &:last-child {
      border-bottom: 0;
    }
    &--title {
      width: 80%;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__buttons {
    display: flex;
    padding: 40 / @w2 0;
    justify-content: center;
  }
  &__confirm-btn {
    width: 60%;
    height: 90 / @w2;
    line-height: 90 / @w2;
    text-align: center;
    border-radius: 5 / @w2;
    background: #3b5999;
    color: #fff;
  }
}
.time-setting-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  /*overflow-y: auto;*/

  .title {
    position: relative;
    height: 132 / @w2;
    line-height: 132 / @w2;
    text-align: center;
    font-size: 16px;
    color: #333;

    i {
      display: inline-block;
      position: absolute;
      font-size: 24 / @w;
      top: -20 / @w;
      right: 5 / @w;
    }
  }

  .days {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    background-color: #f4f4f4;

    .week-head {
      display: flex;
      flex-flow: nowrap;
      align-items: center;
      /*overflow-x: auto;*/
      height: 110 / @w2;
      min-height: 110 / @w2;

      &__day {
        flex: 1;
        display: flex;
        align-items: center;
        flex-flow: column;
        justify-content: center;
        width: 100 / @w2;
        height: 110 / @w2;

        span:first-child {
          margin-bottom: -4 / @w2;
        }
      }

      &__day--active {
        position: relative;
        border-bottom: 3px solid #5b93fc;
        color: #5b93fc;

        /*&:after {*/
        /*position: absolute;*/
        /*content: '';*/
        /*display: inline-block;*/
        /*width: 15px;*/
        /*height: 15px;*/
        /*background-color: #fff;*/
        /*transform: rotate(45deg);*/
        /*bottom: -12px;*/
        /*}*/
      }
      &__day--disabled {
        background-color: #eee;
        color: #999;
      }
    }
  }

  .select-date {
    text-align: right;
    margin-top: 10 / @w;
    margin-right: 10 / @w;
    margin-bottom: -10 / @w;
    font-size: 12px;
    color: #5b93fc;
  }

  .times {
    display: flex;
    flex-flow: wrap;
    width: 375 / @w;
    padding-top: 10 / @w;
    padding-left: 12 / @w;

    &__half-day {
      width: 100%;
      margin-bottom: 15 / @w;
    }

    .cell {
      width: 89 / @w;
      margin-bottom: 6 / @w;

      &__time {
        display: flex;
        padding: 3 / @w 0;
        flex-flow: column;
        align-items: center;
        justify-content: space-around;
        width: 84 / @w;
        height: 40 / @w;
        border-radius: 3px;
        border: solid 1px #e6e6e6;
        color: #666;
      }

      &__time--disabled {
        background-color: #eee;
        color: #999;
      }

      &__time--selected {
        background-color: #5b93fc;
        color: #fff;
      }
    }
  }

  .times:first-of-type {
    margin-bottom: 30 / @w;
  }

  footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50 / @w;
    color: #fff;
    font-size: 16px;
    background-color: #3b5999;
  }
}
</style>
